//src/admin/manage_gallery.js//
import React, { useState, useEffect,useRef  } from 'react';
import {  Button, Typography, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import axios from 'axios';
import BASE_URL from '../config';
const ManageGallery = () => {
  const [albums, setAlbums] = useState([]);
  const [selectedAlbum, setSelectedAlbum] = useState('');
  const [images, setImages] = useState([]);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const fileInputRef = useRef(null);
  // Fetch albums on component mount
  const fetchAlbums = async () => {
    const response = await axios.get(`${BASE_URL}/api/albums`);
    setAlbums(response.data);
  };

  useEffect(() => {
    fetchAlbums();
  }, []);

  const handleAlbumChange = (event) => {
    setSelectedAlbum(event.target.value);
  };

  const handleImageChange = (event) => {
    setImages(event.target.files);
  };

  const handleSubmit = async () => {
    if (!selectedAlbum || images.length === 0) {
      setError('Please select an album and upload images.');
      return;
    }

    const formData = new FormData();
    formData.append('album_id', selectedAlbum);
    for (let i = 0; i < images.length; i++) {
      formData.append('images', images[i]);
    }

    try {
      const response = await axios.post(`${BASE_URL}/api/gallery/upload`, formData);
      setMessage(response.data.message);
      setError('');
      // Clear inputs after successful upload
    setSelectedAlbum('');
    setImages([]);
    //document.getElementById('file-input').value = ''; // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset file input using ref
    }
    } catch (err) {
      setError('Failed to upload images.');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>Manage Gallery</Typography>

      <FormControl fullWidth margin="normal">
        <InputLabel>Select Album</InputLabel>
        <Select value={selectedAlbum} onChange={handleAlbumChange}>
          {albums.map((album) => (
            <MenuItem key={album.album_id} value={album.album_id}>
              {album.album_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <input
       ref={fileInputRef}
        id="file-input"
        type="file"
        multiple
        accept="image/*"
        onChange={handleImageChange}
        style={{ marginTop: '20px', marginBottom: '20px' }}
      />

      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Upload Images
      </Button>

      {error && <Typography color="error" style={{ marginTop: '20px' }}>{error}</Typography>}
      {message && <Typography color="primary" style={{ marginTop: '20px' }}>{message}</Typography>}
    </div>
  );
};

export default ManageGallery;
